import css from './NotificationsQuick.module.scss';
import { svgSprite } from '../../../hybrid/wrappers';
import React, { useEffect, useRef } from 'react';
import { getIcon, getColorNotification } from '../helpers';
const NotificationsQuick = ({ notification }) => {
    const ref = useRef(null);
    useEffect(() => {
        if (ref?.current) {
            setTimeout(() => {
                ref.current.remove();
            }, 15000);
        }
    }, []);

    // const getText = useMemo(() => {
    //     switch (notification?.subject) {
    //         case 'FinanceDocumentPosted':
    //             return (
    //                 <>
    //                     <p className={css.notificationsQuickTitle}>{notification?.message || ''}</p>
    //                 </>
    //             );
    //         case 'BonusPayed':
    //             return (
    //                 <>
    //                     <p className={css.notificationsQuickTitle}>
    //                         {t('notification-BonusPayed', 'Начислен бонус', 'all', translation)}
    //                     </p>
    //                     <p className={css.notificationsQuickSubTitle}>{notification?.message || ''}</p>
    //                 </>
    //             );
    //         case 'MarketingRankAssigned':
    //             return (
    //                 <>
    //                     <p className={css.notificationsQuickTitle}>
    //                         {t('notification-MarketingRankAssigned', 'Вы достигли нового ранга', 'all', translation)}
    //                     </p>
    //                     <p className={css.notificationsQuickSubTitle}>{notification?.message || ''}</p>
    //                 </>
    //             );
    //         case 'UserBecameActive':
    //             return (
    //                 <>
    //                     <p className={css.notificationsQuickTitle}>
    //                         {t('notification-UserBecameActive', 'Активность выполнена', 'all', translation)}
    //                     </p>
    //                     <p className={css.notificationsQuickSubTitle}>{notification?.message || ''}</p>
    //                 </>
    //             );
    //         case 'UserRegistered':
    //             return (
    //                 <>
    //                     <p className={css.notificationsQuickTitle}>
    //                         {t('notification-UserRegistered', 'Новый партнер', 'all', translation)}
    //                     </p>
    //                     <p className={css.notificationsQuickSubTitle}>{notification?.message || ''}</p>
    //                 </>
    //             );
    //         default:
    //             return null;
    //     }
    // }, [notification?.message, notification?.subject, translation]);

    return (
        <div ref={ref} className={css.notificationsQuick}>
            {getIcon(notification?.type?.substring(notification?.type?.lastIndexOf('\\') + 1), css, notification?.subject)}
            <div style={{ flex: 1, marginRight: '16px' }}>
                <p className={css.notificationsQuickTitle}>{notification?.subject || ''}</p>
                <p className={css.notificationsQuickSubTitle}>{notification?.message || ''}</p>
            </div>
            <div className={css.notificationsQuickLoader}>
                <div
                    style={{
                        backgroundColor: getColorNotification(
                            notification?.type?.substring(notification?.type?.lastIndexOf('\\') + 1)
                        )
                    }}
                    className={css.notificationsQuickLoaderProgress}
                ></div>
            </div>
            <div
                onClick={() => {
                    ref?.current?.remove();
                }}
                className={css.notificationsQuickModalClose}
            >
                {svgSprite('cross', {
                    width: '10px',
                    height: '10px',
                    fill: 'var(--greyExtraDarkColor)'
                })}
            </div>
        </div>
    );
};

export default NotificationsQuick;
